import { MenuButton } from "./menu-button.model";
import { PermissionType } from "./permission/permission-type-enum";

/** Main navigation of the app header, in display order (Figma "App shell", node 137:1883). */
export const NavigationItems: MenuButton[] = [
    {
        label: 'menu.home',
        link: 'home',
        icon: 'lucideHouse',
    },
    {
        label: 'menu.requests',
        link: 'requests',
        icon: 'lucideInbox',
        permissions: [PermissionType.AccessRequests],
    },
    {
        label: 'menu.config',
        link: 'config',
        icon: 'lucideSettings2',
    },
    {
        label: 'menu.admin',
        link: 'admin',
        icon: 'lucideSettings',
        roles: ['Admin'],
    },
];
